"use strict";

// Get Element
var eleTime = document.getElementById("time");
function getTheTime() {
  var time = new Date();
  var hours = time.getHours();
  var minutes = time.getMinutes();
  var seconds = time.getSeconds();
  var getPmAm = hours >= 13 ? "Pm" : "Am";
  var ifHours = hours > 9 ? "" : "0";
  var ifMinutes = minutes > 9 ? "" : "0";
  var ifSeconds = seconds > 9 ? "" : "0";
  if (hours >= 13) {
    hours -= 12;
  }
  eleTime.innerHTML = ifHours + hours + ":" + ifMinutes + minutes + ":" + ifSeconds + seconds + " " + getPmAm;
}
(function () {
  setInterval(getTheTime, 500);
})();

//
/*  DARK LIGHT THEME  */
var themeButton = document.getElementById("theme-button");
var darkTheme = "dark-theme";
var iconTheme = "bx-sun";

// Previously selected topic (if user selected)
var selectedTheme = localStorage.getItem("selected-theme");
var selectedIcon = localStorage.getItem("selected-icon");

// We obtain the current theme that the interface has by validating the dark-theme class
var getCurrentTheme = function getCurrentTheme() {
  return document.body.classList.contains(darkTheme) ? "dark" : "light";
};
var getCurrentIcon = function getCurrentIcon() {
  return themeButton.classList.contains(iconTheme) ? "bx-moon" : "bx-sun";
};

// We validate if the user previously chose a topic
if (selectedTheme) {
  // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the dark
  document.body.classList[selectedTheme === "dark" ? "add" : "remove"](darkTheme);
  themeButton.classList[selectedIcon === "bx-moon" ? "add" : "remove"](iconTheme);
}

// Activate / deactivate the theme manually with the button
themeButton.addEventListener("click", function () {
  // Add or remove the dark / icon theme
  document.body.classList.toggle(darkTheme);
  themeButton.classList.toggle(iconTheme);
  // We save the theme and the current icon that the user chose
  localStorage.setItem("selected-theme", getCurrentTheme());
  localStorage.setItem("selected-icon", getCurrentIcon());
});